module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showSection) ? _c('div', {
    staticClass: "SectionBorderTop grid-narrow-left-column"
  }, [_c('div', {
    staticClass: "left"
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-3"
  }, [(_vm.hasForecastManagerComment) ? _c('div', [_c('div', {
    staticClass: "SectionTitle"
  }, [_vm._v("Forecast Manager comments/recommendations")]), _vm._v(" "), _c('div', {
    staticClass: "comment"
  }, [_c('MultiLineText', {
    attrs: {
      "text": _vm.forecast.comments
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3"
  }, [(_vm.forecastWindow && _vm.forecastWindow.supervisorComment) ? _c('div', [_c('div', {
    staticClass: "SectionTitle"
  }, [_vm._v("Export Manager comments/recommendations")]), _vm._v(" "), _c('div', {
    staticClass: "comment"
  }, [_c('MultiLineText', {
    attrs: {
      "text": _vm.forecastWindow.supervisorComment
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3"
  }, [(_vm.forecastWindow && _vm.forecastWindow.comment) ? _c('div', [_c('div', {
    staticClass: "SectionTitle"
  }, [_vm._v("Market comments/requests")]), _vm._v(" "), _c('div', {
    staticClass: "comment"
  }, [_c('MultiLineText', {
    attrs: {
      "text": _vm.forecastWindow.comment
    }
  })], 1)]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-3"
  }, [_vm._t("default")], 2)])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-551baa59","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forecasts/pages/sections/Comments.vue
// module id = 3192
// module chunks = 0